// Helper function to return border-radius based on size
const getBorderRadius = size => {
  switch (size) {
    case 'small':
      return '6px'
    case 'large':
      return '10px'
    case 'medium':
    default:
      return '8px'
  }
}
export default getBorderRadius
